require('./bootstrap');

window.Vue = require('vue').default;

import VueRouter from 'vue-router'
Vue.use(VueRouter);

import router from './router'
import store from './store'

//import './plugins/bootstrap-vue'
//import './plugins/vee-validate'

Vue.config.productionTip = false

Vue.component('EstadoPagoDinamico', require('./views/pagina/inicio/EstadoPagoDinamico.vue').default);
Vue.component('EstadoPagoDinamicoHites', require('./views/pagina/inicio/EstadoPagoDinamicoHites.vue').default);
Vue.component('ConfirmacionAppRedDatos', require('./views/pagina/inicio/ConfirmacionAppRedDatos.vue').default);
Vue.component('ConfirmacionFalabella', require('./views/pagina/inicio/ConfirmacionFalabella.vue').default);
Vue.component('ComercioAbono', require('./views/pagina/comercio/ComercioAbono.vue').default);

const app = new Vue({
    el: '#app',
    router,
    store
});
